import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

export const calendarSubscriptionSchema = z.object({
  id: uuidSchema,
  name: z.string(),
  url: z.string().url(),
  lastSyncAt: isoDateStringSchema.nullable(),
  createdAt: isoDateStringSchema,
});
export type CalendarSubscription = z.infer<typeof calendarSubscriptionSchema>;

export const createCalendarSubscriptionRequestSchema = z.object({
  name: z.string().min(1).max(200),
  url: z.string().url().max(2000),
});
export type CreateCalendarSubscriptionRequest = z.infer<
  typeof createCalendarSubscriptionRequestSchema
>;

export const updateCalendarSubscriptionRequestSchema = z
  .object({
    name: z.string().min(1).max(200).optional(),
    url: z.string().url().max(2000).optional(),
  })
  .refine((v) => v.name !== undefined || v.url !== undefined, {
    message: 'At least one field must be provided',
  });
export type UpdateCalendarSubscriptionRequest = z.infer<
  typeof updateCalendarSubscriptionRequestSchema
>;

export const syncCalendarSubscriptionResponseSchema = z.object({
  inserted: z.number().int().nonnegative(),
});
export type SyncCalendarSubscriptionResponse = z.infer<
  typeof syncCalendarSubscriptionResponseSchema
>;
